"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_jss_1 = require("react-jss");
var Utility_1 = require("../../../Icons/Utility");
var RadioButton_1 = __importDefault(require("../../../RadioButton"));
var Typography_1 = require("../../../Typography");
var styles_1 = __importDefault(require("../styles"));
var useStyles = (0, react_jss_1.createUseStyles)(styles_1.default);
// eslint-disable-next-line no-redeclare
var RadioGroup = function (_a) {
    var children = _a.children, className = _a.className, defaultValue = _a.defaultValue, disabled = _a.disabled, errorMessage = _a.errorMessage, groupLabel = _a.groupLabel, helperText = _a.helperText, onChange = _a.onChange, options = _a.options, name = _a.name, showGroupLabel = _a.showGroupLabel, twoColumn = _a.twoColumn, tooltip = _a.tooltip, divProps = __rest(_a, ["children", "className", "defaultValue", "disabled", "errorMessage", "groupLabel", "helperText", "onChange", "options", "name", "showGroupLabel", "twoColumn", "tooltip"]);
    (0, react_1.useEffect)(function () {
        if ((options && options.length > 5) || react_1.default.Children.count(children) > 5)
            console.warn('Passing more than 5 options to a RadioGroup is discouraged – consider using a SelectBox instead. See https://mortar.policygenius.com for more details.');
    }, [options, children]);
    var hasError = !!errorMessage;
    var classes = useStyles({ error: hasError });
    var radioGroupLabelId = "".concat(name, "_label");
    var helperTextId = "".concat(name, "_helperText");
    // if groupLabel is visible, mark which element labels the group
    // otherwise, add an aria-label
    var radioGroupProps = (function () {
        var ariaAttrs = {};
        if (showGroupLabel) {
            ariaAttrs['aria-labelledby'] = radioGroupLabelId;
        }
        else {
            ariaAttrs['aria-label'] = groupLabel;
        }
        if (helperText) {
            ariaAttrs['aria-describedby'] = helperTextId;
        }
        return ariaAttrs;
    })();
    var _b = (0, react_1.useState)(defaultValue !== null && defaultValue !== void 0 ? defaultValue : ''), value = _b[0], setValue = _b[1];
    var handleChange = function (event) {
        setValue(event.target.value);
        typeof onChange === 'function' && onChange(event);
    };
    var renderRadioInputsWithChildren = function () {
        return react_1.default.Children.map(children, function (child) {
            if (!(react_1.default.isValidElement(child) &&
                child.type === RadioButton_1.default)) {
                console.warn('RadioButton is the only valid child of RadioGroup. Other nodes will be skipped.');
                return null;
            }
            return react_1.default.cloneElement(child, {
                className: (0, classnames_1.default)(classes.inputWrapper, child.props.className),
                disabled: child.props.disabled || disabled,
                error: hasError,
                name: name
            });
        });
    };
    var renderRadioInputsWithOptions = function () {
        return options === null || options === void 0 ? void 0 : options.map(function (option) { return (react_1.default.createElement(RadioButton_1.default, { key: "".concat(name, "_").concat(option.value), className: (0, classnames_1.default)(classes.inputWrapper), disabled: option.disabled || disabled, error: hasError, value: option.value, helpText: option.helpText, checked: option.value === value, name: name, label: option.label, onChange: handleChange })); });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", __assign({ role: "radiogroup", className: (0, classnames_1.default)(className, classes.wrapper, twoColumn && classes.twoColumn) }, radioGroupProps, divProps),
            (showGroupLabel || helperText) && (react_1.default.createElement("div", { className: classes.groupDescriptionWrapper },
                showGroupLabel && (react_1.default.createElement("span", { className: classes.legendAndTooltipWrapper },
                    react_1.default.createElement(Typography_1.LabelText, { color: disabled ? 'disabled' : 'primary', size: "large", id: radioGroupLabelId }, groupLabel),
                    tooltip)),
                helperText && (react_1.default.createElement(Typography_1.UtilityText, { color: disabled ? 'disabled' : 'secondary', size: "xsmall", id: helperTextId }, helperText)))),
            options
                ? renderRadioInputsWithOptions()
                : renderRadioInputsWithChildren()),
        errorMessage && (react_1.default.createElement(Typography_1.UtilityText, { size: "xsmall", color: "secondary", className: classes.errorTextWrapper },
            react_1.default.createElement("span", { className: classes.errorIconWrapper },
                react_1.default.createElement(Utility_1.AlertWarning, { size: "medium", color: "warningAccessible", ariaHidden: true })),
            errorMessage))));
};
exports.default = RadioGroup;
